import React from "react";
import { Col, Row } from "react-bootstrap";

const GridTypeTable = ({
  data = [],
  renderCardHeader,
  renderCardBody,
  renderCardFooter,
  emptyMessage = "No data found",
  gridColumns = { lg: 3, md: 4, sm: 6, xs: 12 },
  t,
  onCardClick,
}) => {
  if (!data?.length) {
    return (
      <div className="empty-cards">
        <p>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="card-grid-container">
      <Row>
        {data.map((item) => (
          <Col
            key={item._id}
            lg={gridColumns.lg}
            md={gridColumns.md}
            sm={gridColumns.sm}
            xs={gridColumns.xs}
          >
            <div
              className="grid-card"
              onClick={() => onCardClick?.(item)}
              style={onCardClick ? { cursor: "pointer" } : {}}
            >
              {renderCardHeader && (
                <div className="card-header">{renderCardHeader(item, t)}</div>
              )}

              {renderCardBody && (
                <div className="card-body">{renderCardBody(item, t)}</div>
              )}

              {renderCardFooter && (
                <div className="card-footer">{renderCardFooter(item, t)}</div>
              )}
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default GridTypeTable;